<template>
    <div class="uk-card uk-card-default uk-card-body uk-text-left">
        <ul class="uk-list uk-list-divider">
            <li>
                <h3>Event Code</h3>
                <p>The Online Event Code is case sensitive, please ensure this is entered as it appears on the online orders card.</p>
            </li>
            <li>
                <h3>Gallery Preview</h3>
                <p>Please understand that all all images show are for preview purposes only and will be fully edited by our professional design team AFTER YOUR PURCHASE HAS BEEN PLACED.</p>
            </li>
            <li>
                <h3>Free pick up from our studio in Newcastle</h3>
                <p>
                    Landon Road Photographers,<br>
                    3 Fellgate Court,<br>
                    Newcastle-under-Lyme,<br>
                    ST5 2UA<br>
                    <a class="uk-button uk-button-default uk-input-rounded uk-width-medium uk-margin" target="_blank" href="https://www.google.com/maps/place/Landon+Road+Photographers/@53.0123258,-2.2293253,18z/data=!4m8!1m2!3m1!2sLandon+Road+Photographers!3m4!1s0x0:0xad35d3a66b3740fa!8m2!3d53.0119629!4d-2.2304092">Open in maps</a> <br>
                </p>
            </li>
            <li>
                <h3>Contact Us</h3>
                <p>If you have any issues with your online code, or need help ordering, please get in touch.</p>
                <a class="uk-button uk-button-default uk-input-rounded uk-width-small uk-margin" href="mailto:info@landonroadphotographers.com">Email</a> info@landonroadphotographers.com<br>
                <a class="uk-button uk-button-default uk-input-rounded uk-width-small" href="tel:07861683382">Telephone</a> 07861 683382<br>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    data() {
        return {
            //
        }
    },
};
</script>
